// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12U2K","primary":"styles_primary__3HQ5-","secondary":"styles_secondary__2pJ5d","bare":"styles_bare__2V8mU","danger":"styles_danger__3afeB"};